// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useState} from 'react';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {t_order} from '../../../../hola/pub/ui/pro/cp/orders';
import {use_etask} from '../../../../hola/pub/lib/use_etask';
import {Text_input} from '../../../../shared/ui/input';
import {Btn_loader as Btn_loader_oculus} from '../../../../oculus/pub/ui/common/btn_loader';
import {Btn_loader} from './btn_loader';
import cn from 'classnames';
import {api} from '../../lib/api';
import {Button} from '../../../../oculus/pub/lib/button';
import {www_hola} from 'hola_opt';

import popup_styles from './plan_table_popup/plan_table_popup.module.less';

export interface i_bw_popup_props {
    per_gb: number;
}

interface i_additional_bw_props extends i_bw_popup_props {
    order: t_order;
    on_success: ()=>void;
    amount: number;
    min_amount: number;
    on_change: (value: string)=>void;
    on_blur: ()=>void;
    on_error: (err: string)=>void;
}
export const Additional_bandwidth = (props: i_additional_bw_props)=>{
    const {order, on_success, amount, per_gb, min_amount, on_change,
        on_blur, on_error} = props;
    const {theme} = useContext(Settings_context);
    const is_toolip = www_hola.site == 'toolip';
    const is_bw_renew_visible = !order.extra_limit_renewal?.enable &&
        order.allowed_bw_renewal;
    const [auto_renew, set_auto_renew] = useState(is_bw_renew_visible);
    const buy_extra = (o: t_order, gb: number)=>
        api.buy_extra_limit({
            ...order.group_id ? {group_id: order.group_id}: {zone_id: o._id},
            gb, auto_renew});
    const {exec, state} = use_etask<[t_order, number],
        {success: boolean, error: string}>(buy_extra);
    const on_submit = ()=>exec(order, amount);
    const input_disabled = state.loading;
    const btn_price = (per_gb*amount).toFixed(2);
    const btn_disabled = state.loading || !amount || amount < min_amount;
    const btn_cls = cn(popup_styles.popup_btn,
        {
          [popup_styles.toolip_additional_btn]: is_toolip,
          [popup_styles.loading]: state.loading
        });
    const btn_caption = <>
      <span className={popup_styles.btn_loader}>
        {is_toolip ? <Btn_loader/> : <Btn_loader_oculus/>}
      </span>
      <span className={popup_styles.btn_text}>
        {amount > 0 ? `$${btn_price} - Pay now` : 'Pay now'}
      </span>
    </>;
    const input_label = is_bw_renew_visible &&
        <p className={cn(theme.p14, theme.color_n700,
          popup_styles.label)}>
          Add bandwidth (GB)
        </p>;
    const toolip_input_label = <p className={cn(theme.p12, theme.color_n400,
      popup_styles.label)}>Number of GB</p>;
    useEffect(()=>{
        if (state.data?.error)
            on_error(state.data.error);
        if (state.data?.success)
            on_success();
    }, [state.data]);
    return <div className={cn(popup_styles.additional_bw, {
      [popup_styles.toolip_additional_bw]: is_toolip,
    })}>
      {is_toolip ? toolip_input_label : input_label}
      <div className={popup_styles.form}>
        <Text_input value={`${amount > 0 ? amount : ''}`} on_change={on_change}
          placeholder='10GB'
          is_disabled={input_disabled} input_props={{onBlur: on_blur}}/>
        <Button size="m" cls={btn_cls} caption={btn_caption}
          on_click={on_submit} disabled={btn_disabled}
        />
      </div>
      {is_bw_renew_visible && !is_toolip &&
      <div className={popup_styles.radio_buttons}>
        <label>
          <input
            type="radio" value="auto"
            checked={auto_renew}
            onChange={()=>set_auto_renew(true)}/>
            Auto-renewal
        </label>
        <label>
          <input
            type="radio" value="one_time"
            checked={!auto_renew}
            onChange={()=>set_auto_renew(false)}/>
            One-time
        </label>
      </div>}
    </div>;
};
